<template>
  <div
    class="tab-content bottom-to-top--effect"
    v-show="title == selectedTitle"
    v-if="!map">
    <slot />
  </div>
  <div
    class="tab-map bottom-to-top--effect"
    v-show="title == selectedTitle"
  v-else>
    <slot />
  </div>



</template>

<script setup>
  defineProps({
    title: String,
    map:{
      type:Boolean,
      default:false
    }
  })

  import { inject } from 'vue'

  const selectedTitle = inject('selectedTitle')
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .tab-content {
    @include d-flex(column, flex-start, initial);
    gap: 20px;
    width: 100%;
    @media screen and (min-width: $sm-breakpoint) {
      @include d-flex(row, flex-start, center,50px);
    }
  }

  .tab-map {
    @include d-flex(column, flex-start, initial);
    gap: 20px;
    width: 100%;
    @media screen and (min-width: $sm-breakpoint) {
      display: grid;
      gap: 50px;
      grid-template-columns: repeat(1, 1fr); 
    }
    @media screen and (min-width: $md-breakpoint) {
      grid-template-columns: repeat(2, 1fr); 
    }
    @media screen and (min-width: $lg-breakpoint) {
      grid-template-columns: repeat(2, 1fr); 
    }
  }


</style>
